<template>
  <div class="column_center_around order_method_container" :class="{ 'h-52': !storeHasDineInTables }">
    <div class="row_center_center" v-if="storeHasDineInTables">
      <text class="title">桌號</text>
      <text class="title" style="color: #c0462e;">必選</text>
    </div>  
    <div v-if="storeHasDineInTables" class="table_select" :class="tableName ? 'row_center_center' : 'row_center_between'" @click="showTableOption = true">
      <text class="text-center font-normal" :class="tableName ? 'text-black' : 'text-[rgba(0,0,0,0.3)]'">{{ tableName || '請選擇桌號' }}</text>
      <text id="expand_more" class="button-icon" style="color: #FBCB02; font-size: 28px; width: 28px; height: 28px;"
        v-if="!tableName">expand_more</text>
    </div>
    <button class="button" @click="toOrderPage">開始點餐</button>
    <SelectDineInTable :tableOptions="dineInTables" v-if="showTableOption" @close="showTableOption = false" @setTable="setTableData" />
  </div>
</template>
<script>
import commonUtilities from "@/utils/common.utils";
import selectDineInTable from "./selectDineInTable.vue";
export default {
  components: {
    SelectDineInTable: selectDineInTable,
  },
  data() {
    return {
      tableData: {},
      showTableOption: false
    };
  },
  computed: {
    getCurrentStore() {
      return this.$store.state.basic.currentStore;
    },
    dineInTables() {
      return this.$store.getters['spreadsheet/dineInTables']
    },
    tableName() {
      return this.$store.getters['cart/tableName']
    },
    areaId() {
      return this.$store.getters['cart/tableAreaId']
    },
    tableIndex() {
      return this.$store.getters['cart/tableIndex']
    },
    storeHasDineInTables() {
      return this.dineInTables.length >= 1
    }
  },
  methods: {
    toOrderPage() {
      if (this.storeHasDineInTables && (!this.areaId || !this.tableName)) {
        commonUtilities.createToast('warning', '請選擇桌號')
        return
      }
      if (!this.storeHasDineInTables) {
        this.$store.commit('cart/setTableData', {
          areaId: null,
          tableIndex: -1,
        })
      }
      const data = {
        method: 'dineIn'
      }
      this.$emit('toOrderPage', data)
    },
  },
};
</script>
<style lang="scss" scoped>
.table_select {
  width: 100%;
  height: 54px;
  padding: 0 4%;
  border: #AAAAAA 1px solid;
  border-radius: 6px;
  color: #000;
  font-size: 22px;
  font-weight: 500;
  font-family: PingFang SC;
  margin: 18px 0 15px;
}
</style>
